const CCV_YELLOW = "#ffc72e";
const CCV_TEAL = "#00b398";

const BROWN_REDS = {
  50: "#ffe3e3",
  100: "#ffb2b3",
  200: "#fd8181",
  300: "#fb5050",
  400: "#f9201f",
  500: "#e00a06",
  600: "#af0404",
  700: "#7e0102",
  800: "#4d0000",
  900: "#1f0000",
};
const BROWN_BROWNS = {
  50: "#fdefe7",
  100: "#e7d4cb",
  200: "#d3b9ab",
  300: "#c19e8b",
  400: "#ae836b",
  500: "#946951",
  600: "#74513e",
  700: "#543a2c",
  800: "#332318",
  900: "#170a00",
};
const CCV_TEALS = {
  50: "#d9fffc",
  100: "#adfff3",
  200: "#7dffec",
  300: "#4dffe4",
  400: "#25ffdc",
  500: "#14e6c3",
  600: "#00b398",
  700: "#00806c",
  800: "#004e41",
  900: "#001c16",
};
const SUCCESS = {
  50: "#e0ffdf",
  100: "#b1ffb0",
  200: "#81ff7f",
  300: "#4fff4d",
  400: "#22ff1d",
  500: "#0fe606",
  600: "#03b300",
  700: "#008000",
  800: "#004d00",
  900: "#001b00",
};
const DANGER = {
  50: "#ffe2e2",
  100: "#ffb1b2",
  200: "#ff7f7f",
  300: "#ff4d4d",
  400: "#fe1d1b",
  500: "#e50501",
  600: "#b30000",
  700: "#810000",
  800: "#4f0000",
  900: "#200000",
};

const colors = {
  primary: CCV_TEALS,
  success: SUCCESS,
  danger: DANGER,
  red: BROWN_REDS,
  secondary: BROWN_BROWNS,
  ccvYellow: CCV_YELLOW,
  ccvTeal: CCV_TEAL,
};

export { colors };
